const RE = /^(\d+)\.(\d+)\.(\d+)(?:-([0-9A-Za-z.-]+))?(?:\+[0-9A-Za-z.-]+)?$/;

export const SEMVER_RE = RE;

/** Compare deux versions semver exactes (négatif : a < b). Une préversion précède sa version finale. */
export function compareSemver(a: string, b: string): number {
  const ma = RE.exec(a);
  const mb = RE.exec(b);
  if (!ma || !mb) return a.localeCompare(b);
  for (let i = 1; i <= 3; i++) {
    const d = Number(ma[i]) - Number(mb[i]);
    if (d !== 0) return d;
  }
  const pa = ma[4];
  const pb = mb[4];
  if (pa === pb) return 0;
  if (pa === undefined) return 1;
  if (pb === undefined) return -1;
  return pa.localeCompare(pb, 'en', { numeric: true });
}
